"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var _get = _interopRequireDefault(require("transmute/get"));

var _getIn = _interopRequireDefault(require("transmute/getIn"));

var _TimeRange = _interopRequireDefault(require("MeetingsBase/models/TimeRange"));

var _PublicMeetingsUser = _interopRequireDefault(require("./PublicMeetingsUser"));

var defaults = {
  id: null,
  busyTimes: (0, _immutable.List)(),
  offline: false,
  firstName: null,
  lastName: null,
  email: null,
  meetingsUser: null
};

var UserBusyTimes =
/*#__PURE__*/
function (_Record) {
  (0, _inherits2.default)(UserBusyTimes, _Record);

  function UserBusyTimes() {
    (0, _classCallCheck2.default)(this, UserBusyTimes);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UserBusyTimes).apply(this, arguments));
  }

  (0, _createClass2.default)(UserBusyTimes, null, [{
    key: "from",
    value: function from(json) {
      return new UserBusyTimes({
        id: json.meetingsUser.id,
        busyTimes: (0, _immutable.List)(json.busyTimes.map(function (b) {
          return _TimeRange.default.from(b);
        })),
        offline: json.isOffline,
        firstName: (0, _getIn.default)(['meetingsUser', 'userProfile', 'firstName'], json),
        lastName: (0, _getIn.default)(['meetingsUser', 'userProfile', 'lastName'], json),
        email: (0, _getIn.default)(['meetingsUser', 'userProfile', 'email'], json),
        meetingsUser: _PublicMeetingsUser.default.from((0, _get.default)('meetingsUser', json))
      });
    }
  }]);
  return UserBusyTimes;
}((0, _immutable.Record)(defaults));

exports.default = UserBusyTimes;
module.exports = exports.default;